import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import {getCompany, editCompany, uploadCompanyIcon} from "../../actions/company";
import { uploadUserIcon, editUser } from "../../actions/auth";
import Company from "./Company";
import User from "./User";
import ApprovalWorkflowList from "./approvalWorkflows/ApprovalWorkflowList";
import StageNamesList from "./approvalWorkflows/StageNamesList";
import {setActiveSidebarPage} from "../../actions/core";
import {logout} from "../../actions/auth";

export function Settings(props) {

    // when component mounts, ensure global state has projects
    useEffect(() => {
        props.setActiveSidebarPage("settings");
        props.getCompany();
    }, []);

    // GLOBAL STATE --------------------------------------------------------------------------------------------------------------------------
    const user = useSelector(state => state.auth.user);
    const company = useSelector(state => state.company.company);
	const status = useSelector( (state) => state.auth.status );
    const isCompanyAdmin = useSelector(state => state.auth.user.croles && state.auth.user.croles["Company Admin"]);

    // LOCAL STATE --------------------------------------------------------------------------------------------------------------------------
	const [newUserInfo, setNewUserInfo] = useState(user);
    const [newCompanyInfo, setNewCompanyInfo] = useState({});
    const [initialCompanyInfo, setInitialCompanyInfo] = useState({});
	const [selectedFiles, setSelectedFiles] = useState([]);
    const [mode, setMode] = useState("view");
    const [submittingUser, setSubmittingUser] = useState(false);
    const [submittingCompany, setSubmittingCompany] = useState(false);

    // which of the 4 tabs is showing -- derived once from the entry URL so links that land here
    // from elsewhere (e.g. an Approval Workflow's Cancel/Save button) open on the right tab
    const [currentTab, setCurrentTab] = useState(() => {
        const path = props.location && props.location.pathname ? props.location.pathname : "";
        if (path.includes("approval-workflow")) return "approval_workflows";
        if (path.includes("stage-names")) return "stage_names";
        return "user_profile";
    });

    // when company data arrives in global state, set local state to match (only relevant properties)
    useEffect(() => {
        const {name, industry, website_address, phone_number, street, city, country, postal, is_searchable, has_domain, domain} = company;
        const requiredCoProperties = {name, industry, website_address, phone_number, street, city, country, postal, is_searchable, has_domain, domain};
        company.uuid && setNewCompanyInfo(requiredCoProperties);
        company.uuid && setInitialCompanyInfo(requiredCoProperties);
    }, [company]);

    const handleEditUserInfo = (e) => {
        setNewUserInfo({...newUserInfo, [e.target.id]: e.target.value});
    }
    const handleEditCompanyInfo = (e) => {
        setNewCompanyInfo({...newCompanyInfo, [e.target.id]: e.target.value});
    }
    const handleToggleCompanyInfo = (e) => {
        setNewCompanyInfo({...newCompanyInfo, [e.target.id]: !newCompanyInfo[e.target.id]});
    }

    const handleSubmitUserInfo = (e) => {
        e.preventDefault();
        if (submittingUser) return;
        setSubmittingUser(true);
        props.editUser(newUserInfo);
        selectedFiles.map(file => {
			// Initial FormData
            const formData = new FormData();
            formData.append("attachment", file);
            //formData.append("timestamp", (Date.now() / 1000) | 0);
			props.uploadUserIcon(file.path, formData);
        });
        setSelectedFiles([]);
        setMode("view");
        props.history.push("/settings/view");
    }
    const handleSubmitCompanyInfo = (e) => {
        e.preventDefault();
        if (submittingCompany) return;
        setSubmittingCompany(true);
        props.editCompany(company.uuid, newCompanyInfo);
        selectedFiles.map(file => {
			// Initial FormData
            const formData = new FormData();
            formData.append("attachment", file);
            //formData.append("timestamp", (Date.now() / 1000) | 0);
			props.uploadCompanyIcon(file.path, formData);
        });
        setSelectedFiles([]);
        setMode("view");
        props.history.push("/settings/view");
    }

	const handleSwitchMode = (newMode) => {
        setSelectedFiles([]);
        setSubmittingUser(false);
        setSubmittingCompany(false);
        setMode(newMode);
        props.history.push(`/settings/${newMode}`);
    }
    const handleCancel = (section) => {
        handleSwitchMode("view");
        section === "company" && setNewCompanyInfo(initialCompanyInfo);
        section === "user" && setNewUserInfo(user);
    }

    const checkURL = (e) => {
		var string = e.target.value;
		if (string.startsWith("www.")) {
			string = "https://" + string;
		  }
		  e.target.value = string;
		  return e.target.value;
	}

    const handleDrop = files => { 
		//setSelectedFiles([ selectedFiles, files])
        files.map(file => {
            let file_exists = undefined;
            file_exists = selectedFiles.find( ({ path }) => path === file.path );
            if (file_exists == undefined) {
                setSelectedFiles(
                    selectedFiles => [...selectedFiles, file]
                )
            }
        });
    }
    const removeSelectedFile = (file_path) => { 
        setSelectedFiles(selectedFiles.filter((file) => file.path !== file_path));
    }
	const clearUploadInfo = () => {
		setSelectedFiles([])
	}


    return (
        <div className="page-wrapper">
            <h1 className="title header heavy">Settings</h1>
            <div>
                <div id="user_profile_settings" className="tab">
                    <h2 className={"title2 " + (currentTab === "user_profile" ? "heavy" : "heavy-grey")} onClick={() => setCurrentTab("user_profile")}>
                        User Profile
                    </h2>
                    <div className={currentTab === "user_profile" ? "tab-underline" : "tab-underline inactive"}></div>
                </div>
                <div id="company_settings" className="tab">
                    <h2 className={"title2 " + (currentTab === "company" ? "heavy" : "heavy-grey")} onClick={() => setCurrentTab("company")}>
                        Company
                    </h2>
                    <div className={currentTab === "company" ? "tab-underline" : "tab-underline inactive"}></div>
                </div>
                {isCompanyAdmin && company.uuid && !company.is_basic &&
                    <>
                        <div id="approval_workflows_settings" className="tab">
                            <h2 className={"title2 " + (currentTab === "approval_workflows" ? "heavy" : "heavy-grey")} onClick={() => setCurrentTab("approval_workflows")}>
                                Approval Workflows
                            </h2>
                            <div className={currentTab === "approval_workflows" ? "tab-underline" : "tab-underline inactive"}></div>
                        </div>
                        <div id="stage_names_settings" className="tab">
                            <h2 className={"title2 " + (currentTab === "stage_names" ? "heavy" : "heavy-grey")} onClick={() => setCurrentTab("stage_names")}>
                                Stage Names
                            </h2>
                            <div className={currentTab === "stage_names" ? "tab-underline" : "tab-underline inactive"}></div>
                        </div>
                    </>
                }
            </div>

            {currentTab === "user_profile" &&
                <User
                    switchMode={() => handleSwitchMode(mode === "user-edit" ? "view" : "user-edit")}
                    newUserInfo={newUserInfo}
                    handleChange={handleEditUserInfo}
                    handleSubmit={handleSubmitUserInfo}
                    handleCancel={() => handleCancel("company")}
                    isSubmitting={submittingUser}
                    mode={mode}
                    clearUploadInfo={clearUploadInfo}
                    handleDrop={handleDrop}
                    selectedFiles={selectedFiles}
                    removeSelectedFile={removeSelectedFile}
                 />
            }

            {currentTab === "company" &&
                <Company
                    switchMode={() => handleSwitchMode(mode === "company-edit" ? "view" : "company-edit")}
                    handleChange={handleEditCompanyInfo}
                    handleToggle={handleToggleCompanyInfo}
                    handleSubmit={handleSubmitCompanyInfo}
                    handleCancel={() => handleCancel("user")}
                    isSubmitting={submittingCompany}
                    newCompanyInfo={newCompanyInfo}
                    mode={mode}
                    clearUploadInfo={clearUploadInfo}
                    handleDrop={handleDrop}
                    selectedFiles={selectedFiles}
                    removeSelectedFile={removeSelectedFile}
                    checkURL={checkURL}
                 />
            }

            {currentTab === "approval_workflows" && isCompanyAdmin && company.uuid && !company.is_basic &&
                <ApprovalWorkflowList />
            }

            {currentTab === "stage_names" && isCompanyAdmin && company.uuid && !company.is_basic &&
                <StageNamesList />
            }
        </div>
    )
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {logout, getCompany, uploadUserIcon, editUser, editCompany, uploadCompanyIcon, setActiveSidebarPage})(Settings);